import { useMIPManageContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MIPManageContext';
import { NewLeaversModalContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewLeaversModal/NewLeaversModal';
import { LEAVERS_PERSONAL_DATA_FIELDS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewLeaversModal/useNewLeaversModalController';
import { RadioGroup } from '@dealstack/frontend/shared/components/forms/RadioGroup/RadioGroup';
import { Radio } from '@dealstack/frontend/shared/components/fundament/Radio/Radio';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo, useContext } from 'react';
import { FormProvider } from 'react-hook-form';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const NewLeaverPersonalDataRequirements = ({ className }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { personalDataRequirementsForm } = useContext(NewLeaversModalContext);
	const MIPManageController = useMIPManageContext();

	return (
		<div className={className}>
			<FormProvider {...personalDataRequirementsForm}>
				<Content>
					<div>
						<SectionHeader
							size="h4b"
							title={tMipManage('new_leaver.steps.personal_data.title')}
						/>

						<RadioGroup
							label={tMipManage('new_leaver.steps.personal_data.radio_1')}
							name={LEAVERS_PERSONAL_DATA_FIELDS.isBankAccountRequired}
						>
							<Radio
								label={tMipManage('new_leaver.steps.personal_data.yes')}
								value={true}
							/>
							<Radio
								label={tMipManage('new_leaver.steps.personal_data.no')}
								value={false}
							/>
						</RadioGroup>
					</div>
					{MIPManageController?.mipInvestorSettings?.isKycRequired && (
						<div>
							<SectionHeader
								size="h4b"
								title={tMipManage('new_leaver.steps.personal_data.title_2')}
							/>

							<RadioGroup
								label={tMipManage('new_leaver.steps.personal_data.radio_2')}
								name={LEAVERS_PERSONAL_DATA_FIELDS.isKycRequired}
							>
								<Radio
									label={tMipManage('new_leaver.steps.personal_data.yes')}
									value={true}
								/>
								<Radio
									label={tMipManage('new_leaver.steps.personal_data.no')}
									value={false}
								/>
							</RadioGroup>
						</div>
					)}
				</Content>
			</FormProvider>
		</div>
	);
};

const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2em;
	margin-bottom: 4em;
`;

const Memoized = memo(NewLeaverPersonalDataRequirements);
const Styled = styled(Memoized)`
	${RadioGroup} {
		margin-top: 1em;
	}

	${Radio} {
		max-width: 10rem;
	}
`;

export { Styled as NewLeaverPersonalDataRequirements };
